import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes$1 from 'prop-types';
import React from 'react';
import { PropTypes } from '@micromag/core';
import { getColorAsString, getStyleFromBox } from '@micromag/core/utils';
import Text from '@micromag/element-text';

var styles = {"box":"micromag-element-share-incentive-box","tip":"micromag-element-share-incentive-tip"};

var propTypes = {
  className: PropTypes$1.string,
  label: PropTypes.textElement,
  boxStyle: PropTypes.boxStyle
};
var defaultProps = {
  className: null,
  label: null,
  boxStyle: null
};
var ShareIncentive = function ShareIncentive(_ref) {
  var className = _ref.className,
    label = _ref.label,
    boxStyle = _ref.boxStyle;
  var _ref2 = boxStyle || {},
    _ref2$backgroundColor = _ref2.backgroundColor,
    backgroundColor = _ref2$backgroundColor === void 0 ? null : _ref2$backgroundColor;
  var bgColor = getColorAsString(backgroundColor);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.box,
    style: _objectSpread({}, getStyleFromBox(boxStyle))
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10",
    className: styles.tip,
    fill: bgColor
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 0,10 10,10"
  })), /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.text
  }, label))));
};
ShareIncentive.propTypes = propTypes;
ShareIncentive.defaultProps = defaultProps;

export { ShareIncentive as default };
